import React, {useMemo} from "react";
import {Select} from "antd";
import { RouteConfig } from "../../../routers/routers";
import {Link, useParams, useLocation} from "react-router-dom";
import {useTranslate} from "../../../hooks/translate.hook";
import { ExtendedSwitch } from "../../core/router/extended-switch/extended.switch";
import {useRequiredStore} from "../../../utils/store";
import {RootStoreContext} from "../../../stores/root/root.store";
import {isAllowed} from "../../../utils/helpers";
import {useNavigate} from "react-router";
import {decodePathname} from "../../../utils/route";
import "./route.buttons.scss";

export interface RouteTabsProps {
    customSpliceNum?: number;
    withoutRootTabPath?: boolean;
    routes: RouteConfig[];
}

const bindPathParams = (path: string, params: any) => {
    for (let key in params) {
        path = path.replace(":" + key, params[key]);
    }

    return path;
};

export const RouteButtons = <T extends object>({
                                                routes,
                                                withoutRootTabPath = false,
                                                customSpliceNum = 4,
                                            }: RouteTabsProps) => {

    const t = useTranslate();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const params = useParams();
    const decodedPathname = decodePathname(pathname);
    const rootTabPath = withoutRootTabPath
        ? decodedPathname
        : decodedPathname.split("/").slice(0, customSpliceNum).join("/");

    const {
        authStore: { attributes },
    } = useRequiredStore(RootStoreContext);

    const tabs = useMemo(() => routes.filter(route => isAllowed(attributes, route.access) && !route.hidden), []);
    const navigationItems = tabs.map(route => ({
        key: bindPathParams(route.path, params),
        label: t(route.navigationSystemName || route.systemName, {
            defaultValue: route.navigationSystemNameDefault,
        }),
    }));
    const activeKey = navigationItems.find(item => item.key === rootTabPath)?.key;

    return (
        <div className="route-sub-navigation-layout">
            <nav className="route-sub-navigation" aria-label="Section navigation">
                {navigationItems.map(item => {
                    const isActive = item.key === activeKey;

                    return (
                        <Link
                            aria-current={isActive ? "page" : undefined}
                            className={`route-sub-navigation-link${isActive ? " route-sub-navigation-link-active" : ""}`}
                            key={item.key}
                            to={item.key}
                        >
                            {item.label}
                        </Link>
                    );
                })}
            </nav>

            <div className="route-sub-navigation-mobile">
                <Select
                    className="route-sub-navigation-select"
                    onChange={(key) => navigate(key)}
                    options={navigationItems.map(item => ({
                        label: item.label,
                        value: item.key,
                    }))}
                    popupClassName="route-sub-navigation-select-dropdown"
                    value={activeKey}
                />
            </div>

            <div className="route-sub-navigation-content">
                <ExtendedSwitch />
            </div>
        </div>
    );
};
